export default defineNuxtPlugin({
  name: 'NotificationsRoot',
  dependsOn: ['auth-loader:plugin'],
  async setup() {
    const { store: authStore } = useAuth()
    const { useNotifications } = await import('../composables/useNotifications')
    const { support } = useNotifications()

    if (authStore.token) {
      await support.loadUnreadCount()
    }

    watch(() => authStore.token, async (val) => {
      if (val) {
        await support.loadUnreadCount()
      }
    })
  },
})
